// src/utils/textHelper.js
import React from 'react';

export const highlightIndonesiaLestari = (text) => {
  if (!text) return text;

  const regex = /(INDONESIA LESTARI|Indonesia Lestari|SUSTAINABLE INDONESIA|Sustainable Indonesia)/g;

  return text.split(regex).map((part, idx) => {
    if (regex.test(part)) {
      return (
        <span 
          key={idx} 
          className="highlight-lestari"
        >
          {part}
        </span>
      );
    }
    return part;
  });
};
